export enum DeliveryTimeTypes {
  DELIVER_NOW = 0,
  SCHEDULE_ORDER = 1
}

export interface Option<ValueType> {
  label: string
  value: ValueType
}
